import React from 'react';

interface ContactInfoProps {
    icon: string;
    href?: string;
    text: string;
    isClickable?: boolean;
}

const ContactInfo: React.FC<ContactInfoProps> = ({ icon, href, text, isClickable = false }) => {
    const content = (
        <div className="gap-3">
            <span>{icon}</span>
            <span>{text}</span>
        </div>
    );

    if (isClickable && href) {
        return (
            <a href={href} className="link">
                {content}
            </a>
        );
    }

    return content;
};

export default ContactInfo;
